import Action from 'redux/helpers/createAction'
const name = 'keywordPages'

export const getPages = Action(name + '/GET_DOMAIN_KEYWORD_PAGES_DATA', (domainId, filters) => ({
  domainId,
  filters
}))

export const getPagesSuccess = Action(
  name + '/GET_DOMAIN_KEYWORD_PAGES_DATA_SUCCESS',
  (id, pages) => ({
    pages,
    id
  })
)

export const getPagesChanges = Action(name + '/GET_DOMAIN_KEYWORD_PAGES_CHANGES_DATA')

export const getPagesChangesSuccess = Action(
  name + '/GET_DOMAIN_KEYWORD_PAGES_CHANGES_DATA_SUCCESS',
  (id, pages) => ({
    pages,
    id
  })
)

export const getPagesFailure = Action(name + '/GET_DOMAIN_KEYWORD_PAGES_DATA_FAILURE', error => ({
  error
}))

export const exportDomainKeywordPagesExcel = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_PAGES_DATA_EXCEL',
  domainId => ({
    domainId
  })
)

export const exportDomainKeywordPagesCSV = Action(
  name + '/EXPORT_DOMAIN_KEYWORD_PAGES_DATA_CSV',
  domainId => ({
    domainId
  })
)
